import {
  updateSettings,
  sendEmail, updateDeletedUserSettings, getDeletedUserSettings,
} from "@/services/api/app/settings";
import settingsRecipients from "@/store/app/google/settings/settings";

const defaultState = () => ({
  settings: null,
  providerType: 2,
  archiveDeletedUsers: null
})

export default {
  namespaced: true,

  actions: {
    updateSettings({commit, state}, settingsForm) {
      return updateSettings(settingsForm, state.providerType)
        .then((result) => {
          commit('setSettings', result)
          return result
        })
    },

    sendEmail({commit, dispatch}) {
      return sendEmail(2);
    },

    getDeletedUserSettings({ commit }) {
      return getDeletedUserSettings()
        .then((result) => {
          commit('setArchiveDeletedUsers', result.archiveDeletedUsers);
          return result;
        });
    },

    updateDeletedUserSettings({ commit }, archiveDeletedUsers) {
      return updateDeletedUserSettings(archiveDeletedUsers)
        .then((result) => {
          commit('setArchiveDeletedUsers', archiveDeletedUsers);
          return result;
        });
    }
  },

  mutations: {
    setSettings(state, settings) {
      state.settings = settings
    },
    setArchiveDeletedUsers(state, value) {
      state.archiveDeletedUsers = value;
    }
  },

  getters: {},

  state: defaultState(),

  modules: {
    settingsRecipients,
  }
}
